<script setup lang="ts">
import { toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { StatisticsItem } from '../models';
import { formatDate } from '@vueuse/core';

const props = defineProps<DataTableCellProps<any, StatisticsItem>>();
const { item } = toRefs(props);
</script>

<template>
  <div>{{ formatDate(new Date(item.data.createdAt), 'YYYY.MM.DD.') }}</div>
</template>
